import { useEffect, useState } from 'react';
export function usePrefersReducedMotion() {
    const [prefersReducedMotion, setPrefersReducedMotion] = useState(false);
    useEffect(() => {
        const mediaQuery = window.matchMedia('(prefers-reduced-motion: reduce)');
        const handleChange = (event) => setPrefersReducedMotion(event.matches);
        mediaQuery.addEventListener('change', handleChange);
        setPrefersReducedMotion(mediaQuery.matches);
        return () => mediaQuery.removeEventListener('change', handleChange);
    }, []);
    return prefersReducedMotion;
}
